function setJobOptions()
{
  let job_options = [{label:'',value:''}]

  for(let index=0; index<10; index++)
  {
    job_options.push({label:`Job_${index+1}`, value:`Job_${index+1}`})
  }

  return job_options;
}


function setCandidateOptions()
{
  let candidate_options = [{label:'',value:''}]

  for(let index=0; index<10; index++)
  {
    candidate_options.push({label:`Candidate_${index+1}`, value:`Candidate_${index+1}`})
  }

  return candidate_options;
}


export const CommunicationFilterJobOptionsDummyData = setJobOptions();
export const CommunicationFilterCandidateOptionsDummyData = setCandidateOptions();
export const CommunicationFilterGetCommunicationData = { data: []}                                   



